// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_d2-0";
export var headerCellHover = "_d2-1";